// extracted by css-extract-rspack-plugin
export default {"file-info-panel":"styles_file-info-panel__O28HM","group":"styles_group__X5cGT","divider":"styles_divider__0RJ66"};